import CookieConsent from "../components/shared/CookieConsent.vue";

export default {
	head: {
		title: 'Blumar - Congressos & Eventos',
		description: 'A Blumar Congressos e Eventos é a agencia oficial para o evento  - .  Encontre aqui os melhores preços para hospedagem e passagem aérea. Mais de 30 anos de experiência no mercado corporativo de eventos.',
		keywords: 'Congressos, eventos, agencia oficial, hospedagem, hotel, passagem aérea, comparacao de precos, tours, transfers.',
		ogDescription: 'A Blumar Congressos e Eventos é a agencia oficial para o evento  - .  Encontre aqui os melhores preços para hospedagem e passagem aérea. Mais de 30 anos de experiência no mercado corporativo de eventos.',
	},
	globalErrors: {
		serviceUnavailable: 'Não foi possível acessar o serviço. Tente novamente em alguns instantes.',
		serverErrorTitle: 'Algo não saiu como esperado',
		backToSite: 'Voltar para o início',
		loadFailed: 'Não foi possível carregar esta página.',
		tryAgain: 'Tentar novamente',
	},
	header: {
		subtitle: "Congressos, Convenções e Eventos em todo o Brasil",
	},
	navbar: {
		companyProfile: "Apresentação",
		calendar: "Calendário",
		accommodation: "Hospedagem",
		flightBookings: "Passagem",
		transportation: "Transporte",
		preAndPostTours: "Pré & Post Tours",
		localTours: "Tours Locais",
		resume: "Currículo",
		clientsArea: 'Área do cliente',
		exit: 'Sair'
	},
	languageDropdown: {
		languages: {
			Pt: 'Português',
			En: 'English',
			Sp: 'Español',
		},
	},
	loginArea: {
		user: 'Login',
		pass: 'Senha',
		enter: 'Entrar',
		error: {
			title: 'Erro!',
			message: 'Usuario ou senha invalidos'
		}
	},
	home: {
		aboveEventCalendarText: "Selecione um evento abaixo para maiores informações sobre hotéis, tours, ticket aéreo, politicas de cancelamento entre outras.",
		asideYearsTabText: "Selecione o ano e veja os eventos ja confirmados:",
		confirmedEvents: {
			title: "Eventos já confirmados",
			loading: "Carregando eventos...",
			empty: "Nenhum evento confirmado para este período.",
			reviewsLabel: "Avaliações Trustindex",
		},
		hero: {
			videoTitle: "Vídeo de fundo",
			headline: {
				strongStart: "Comprometimento real",
				middle: " em cada etapa",
				endStart: "do ",
				strongEnd: "planejamento à entrega",
			},
		},
	},
	footer: {
		ourContacts: "Nossos Contatos",
		contactLabel: "fale conosco",
		socialLabel: "nossas redes",
		portfolioLabel: "Portfolio",
		address: "Blumar Brasil - Rua Siqueira Campos 43 - cob 2 - CEP: 22031-901 - Copacabana - Rio de Janeiro - Brasil - Tel: 21 2142-9300",
		privacyPolicy: "Política de Privacidade",
	},
	cookieConsent: {
		message: "Quando você navega pelo nosso site, utilizamos cookies e outras tecnologias semelhantes para melhorar a sua experiência, personalizar publicidade, recomendar conteúdo de seu interesse, entre outras funcionalidades. Ao utilizar nossos serviços, você concorda com tal monitoramento. Conheça melhor essas e outras informações acessando e aceitando a nossa",
		privacyPolicy:"Política de Privacidade",
		acceptButton: 'ACEITAR'
	},
	eventCard: {
		betweenDatesText: 'a',
		actionLabel: 'mais sobre esse evento',
		pastLabel: 'evento realizado',
	},
	eventHeader: {
		officialAgency: 'SOMOS A AGÊNCIA OFICIAL DO EVENTO',
	},
	eventPage: {
		periodConnector: 'até',
		optionLabels: {
			hotelReservation: 'Reserva de Hotel',
			flightReservation: 'Reserva Aérea',
			transferReservation: 'Reserva de Transfers',
			localTours: 'Tours Locais',
			aboutBrazil: 'Informações Gerais do Brasil',
			destinationInfo: 'Informações sobre a cidade',
			eventWebsite: 'Website do Evento',
			visaAndVaccine: 'Visto e Vacina',
		},
		officialAgency: {
			title: 'Sobre a Blumar',
			firstParagraph: eventName => `A Blumar Turismo é agência oficial do ${eventName} e a única autorizada pela organização do evento a negociar tarifas e fazer os bloqueios em seu nome. Quaisquer outras agências podem entrar em contato oferecendo hospedagem e bilhetes aéreos, todavia, favor notar que tais agências não tem autorização para negociar em nome do evento e tampouco, acesso aos bloqueios concedidos para o mesmo. Dessa forma, sem nenhuma garantia para o congressista caso haja alguma situação de pagamento, atendimento fraude e garantia das mesmas. Lembramos que toda a equipe de eventos da Blumar Congressos e Eventos esta à disposição para dirimir quaisquer solicitações ou informações que possam ter através do telefone 21 2142 9315 ou no email eventos@blumar.com.br. Obrigado e bom congresso!`,
			secondParagraph: 'Com mais de 30 anos de experiência no mercado corporativo de eventos, a Blumar oferece ainda para a sua comodidade, os serviços de transfers, tours locais e tours pré e pós congresso.',
		},
	},
	prePostTours: {
		title: 'Pré & Post Tours',
		book: 'quero reservar',
		included: 'O pacote inclui:',
		excluded: 'Não inclui:',
		form: {
			title: 'Faça sua solicitação',
			name: 'Nome',
			email: 'E-mail',
			departureDate: 'Data de saída',
			message: 'Mensagem',
			close: 'fechar',
			submit: 'enviar solicitação',
			sending: 'Enviando solicitação...',
			success: 'Solicitação enviada com sucesso!',
			failureTitle: 'Solicitação não enviada.',
			failureMessage: 'Não foi possível enviar sua solicitação. Tente novamente mais tarde.',
		},
	},
	datepicker: {
		previousDecade: 'Década anterior',
		previousYear: 'Ano anterior',
		previousMonth: 'Mês anterior',
		currentMonth: 'Mês atual',
		nextMonth: 'Próximo mês',
		nextYear: 'Próximo ano',
		nextDecade: 'Próxima década',
		today: 'Hoje',
		selectedDate: 'Data selecionada',
		noDateSelected: 'Nenhuma data selecionada',
		calendar: 'Calendário',
		calendarNavigation: 'Navegação do calendário',
	},
	waitModal: {
		title: 'Blumar',
		message: 'Aguarde',
		close: 'Fechar',
	},
	creditCardInfo:{
		title:'Informações do Pagamento',
		nameCreditCard:'Nome (igual ao cartão)',
		numberCreditCard:'Número do cartão (apenas números)',
		code:'Código de Segurança',
		codeInfo:'O que é isso ?',
		expireDate:'Validade (mês/ano)',
		installments:'Número de parcelas',
		receiptData:'Dados para Emissão da Nota Fiscal Eletrônica',
		inscription:'Inscrição',
		inscriptionCPF:'CPF',
		inscriptionCNPJ:'CNPJ',
		state:'Estado',
		uf:'UF',
		city:'Cidade',
		district:'Bairro',
		street: 'Rua',
		number: 'Número',
		complement:'Complemento',
		zipCode:'CEP',
		book: {firstTry: 'reservar', retry: 'pagar'}
	},
	hotelReservationCard: {
		checkinDate: 'Data de chegada',
		checkoutDate: 'Data de saída',
		rooms: 'Quartos',
		guests: 'Hóspedes',
		perRoom: 'Por quarto',
		adults: 'Adultos',
		children: 'Crianças',
		age: (n) => n === 1 ? `${n} ano` : `${n} anos`,
		childrenAges: 'Preencha as idades das Crianças',
		bookHere: 'RESERVE AQUI',
		hotelSearch: 'Pesquisa de Hotéis',
		hotelSearchObs: 'Tarifas por apartamento, por dia em reais (BRL)',
		continueButton: 'CONTINUE',
		installments: 'Parcelamos em ',
		installmentsWithoutTax: ' vezes sem juros.',
		changeReservation: 'Alterar Reserva',
		sortBy: 'Classificar por',
		noResultsFound: 'Nenhum resultado encontrado.',
		mobileSearch: {
			changeSearch: 'alterar busca',
			checkin: 'Chegada',
			checkout: 'Saída',
			double: 'Duplo',
			quadruple: 'Quadruplo',
			resultTitle: 'Resultado Busca',
			searchTitle: 'Reserva de Hotel',
			single: 'Individual',
			triple: 'Triplo',
		},
	},
	hotelBookingPersonalInfo:{
		reservationData: 'Dados da reserva',
		hotel: 'Hotel',
		room: 'Apartamento',
		rooms: 'Apartamentos',
		roomGuests: 'Hóspedes do apartamento',
		quantity: 'Quantidade',
		allocationTypeSGL: 'Individual',
		allocationTypeDBL: 'Duplo',
		allocationTypeTPL: 'Triplo',
		allocationTypeQPL: 'Quadruplo',
		checkin: 'Data de chegada',
		checkout: 'Data de saída',
		dailyPrice: 'Diárias',
		breakfast: 'Café da manhã',
		breakfastIncluded: 'Incluso',
		breakfastNotIncluded: 'Não incluso',
		taxes: 'Taxas',
		total: 'Total',
		fillFields: 'Preencha os campos abaixo',
		paxInfo: 'informações do titular da reserva',
		pax: 'Titular da reserva',
		name: 'Nome',
		email: 'Email',
		phone: 'Telefone',
		country: 'País',
		specialRequest: 'Solicitação especial',
		continue: 'CONTINUAR',
		resume: 'RESUMO DA RESERVA',
		guests: 'Hóspedes',
		book: 'RESERVE AQUI',
		searchAgain: 'BUSCAR NOVAMENTE',
	},
	destinationInfo:{
		title:'INFORMAÇÕES DA CIDADE'
	},
	flightReservation: {
		flightReservationTitle: 'COMPRAR PASSAGENS AÉREAS',
		departureDate: 'Data da Partida',
		returnDate: 'Data do Retorno',
		adults: 'Adultos',
		children: 'Crianças',
		age: (n) => n === 1 ? `${n} ano` : `${n} anos`,
		babies: 'Bebês',
		childrenAges: 'Preencha as idades das Crianças',
		origin: 'Origem',
		destination: 'Destino',
		originPlaceholder: 'Digite sua origem',
		destinationPlaceholder: 'Digite sem destino',
		continueButton: 'CONTINUE',
	},
	flightRequestOffline: {
		title: 'RESERVA AÈREA',
		description: 'A Blumar negociou excelentes tarifas de voos dentro do Brasil para todos os participantes',
		with: ' com ',
		discount: 'DESCONTOS A PARTIR DE ',
		formTitle: 'Formulário de reserva de companhia aérea',
		descriptionForm: 'Após preencher este formulário você receberá um e-mail com outras opções de voos com valor e forma de pagamento.',
		personalDetails: 'Detalhes pessoais',
		fullName: 'NOME COMPLETO',
		email: 'E-MAIL',
		phone: 'TELEFONE',
		departureAirport: 'AEROPORTO DE PARTIDA',
		class: 'Classe',
		departureDate: 'DATA DE PARTIDA',
		returnDate: 'DATA DE RETORNO',
		period: 'PERIODO',
		mourning: 'Manhã',
		afternoon: 'Tarde',
		evening: 'Noite',
		originPlaceholder: 'Digite sua origem',
		send: 'Enviar',
		invalidDate: 'Erro! Data de partida não pode ser definida como depois da data de retorno.',
		conclusion: {
			success: {
				title: 'Sucesso!',
				message: 'Solicitação enviada com sucesso!'
			},
			fail: {
				title: 'Erro ao enviar a solicitação!',
				message: 'Não foi possível enviar sua solicitação! Tente novamente mais tarde!'
			}
		},
		wait: 'Aguarde'
	},
	eventPromoterWebsite:{
		accessWebsite:'Acesse o site do evento através do link: ',
		notFounded: 'Site não encontrado.'
	},
	transferReservation:{
		title:'RESERVA DE TRANSFER',
		searchTitle:'BUSCA DE TRANSFER',
		resume: 'RESUMO DA RESERVA',
		search: 'Buscar',
		searchAgain: 'Buscar novamente',
		wait: 'Aguarde..',
		responsible: 'Dados dos responsável pela reserva',
		paxNumber: 'Nº de Passageiros',
		date: 'Data',
		fullName: 'Nome Completo',
		name:'Nome',
		email:'E-mail',
		country:'País',
		result: 'Resultado',
		noResult: 'Nenhum resultado encontrado',
		resultTitle: 'Resultado transfers disponíveis',
		detail:{
			origin:'Origem',
			destination:'Destino',
			title: 'Detalhes da reserva',
			pax: 'Passageiro',
			birthdate: 'Data de nascimento',
			hour: 'Hora',
			flightCompany: 'Companhia aérea',
			flightNumber: 'Número do voo',
			observation: 'Observações',
			price: 'Total',
			pricePerPerson: 'Preço por pessoa',
			select: 'Selecionar',
			close: 'Fechar',
			add: 'Adicionar',
			remove: 'Remover transfer',
			addAnotherTransfer: 'Adicionar outro transfer'
		},
		changeReservation: 'Alterar Reserva',
	},
	hotelPrices: {
		breakfastIncluded: 'Café da manhã incluso',
		breakfastNotIncluded: 'Café da manhã não incluso',
		hotelInfo: 'Informações do hotel',
		book: 'Reservar',
		soldOut: 'Esgotado',
		location: 'Localização:',
		eventDistance: 'Distância do evento:'
	},
	flightReservationCard: {
		origin: 'Origem',
		destination: 'Destino',
		checkinDate: 'Data de chegada',
		checkoutDate: 'Data de saída',
		adults: 'Adultos',
		kids: 'Crianças',
		babies: 'Bebês',
		bookHere: 'RESERVE AQUI'
	},
	aboutBrazil: {
		title: 'Informações gerais',
		menu: {
			health: 'Saúde',
			money: 'Moeda',
			time: 'Horário',
			electricity: 'Eletricidade',
			language: 'Idioma',
			climate: 'Clima',
			tipping: 'Gorjetas',
			taxes: 'Taxas',
			brazillianFoodAndDrink: 'Comidas',
			clothing: 'Vestuário',
			shopping: 'Compras',
			generalSecurity: 'Segurança',
			beaches: 'Praias',
		},
		content: [
			{
				menu: 'Saúde',
				content: 'Não há exigências obrigatórias para se entrar no Brasil. Aconselha-se tomar precauções contra a febre amarela, pólio, tifo e malária. Sugerimos que você entre em contato com o Consulado do Brasil mais próximo para obter informações atualizadas. É recomendado que você esteja coberto por um seguro de saúde abrangente. Atenção: Se você for entrar no Brasil pelo Peru, Equador ou Colômbia, deverá apresentar certificado atualizado de vacinação contra a febre amarela ao controle de passaportes. Dieta local: Aconselha-se tomar precauções contra males intestinais enquanto não se houver adaptado à mudança na dieta. Evite comer e beber produtos oferecidos à venda por ambulantes e restaurantes com práticas duvidosas de higiene e refrigeração. Não se recomenda tomar água da torneira, especialmente nas áreas rurais, devido a provável contaminação. Limite seu consumo de água ao produto engarrafado. Mesmo com o tratamento que a água recebe nas grandes cidades, e porque os produtos químicos são diferentes dos que você está acostumado, continuamos a recomendar que você beba água mineral. A evitar: peixe cru, frutos do mar, refrescos, cubos de gelo, sorvete, queijos frescos, iogurte, ou qualquer produto vendido por ambulantes.'
			},
			{
				menu: 'Moeda',
				content: 'A moeda brasileira é o REAL. Cem centavos = 1 real. As notas bancárias estão em denominações de 100, 50, 10, 5, 2 e 1; As moedas: 1,00 real; 50 centavos, 25 centavos, 10 centavos, 5 centavos e 1 centavo. Todas as casas de câmbio aceitam travellers cheques. Em geral, aceita-se trocar uma grande variedade de moedas estrangeiras, no entanto recomendamos que traga dólares americanos e ou travellers cheques nessa mesma moeda, posto que esta troca-se mais facilmente que qualquer outra. Em alguns hotéis e restaurantes, você poderá se beneficiar de desconto de até 15% ao pagar sua conta em dinheiro estrangeiro ou travellers cheques.Subsiste o mercado de câmbio negro, no entanto recomendamos com firmeza que você ignore qualquer um que se aproxime querendo saber se você quer trocar dinheiro. Caso aceite, é quase certo que você será roubado.Cartões de Crédito - Access/Mastercard, American Express, Diners Club e Visa são aceitos na vasta maioria dos hotéis, lojas e restaurantes.Bancos - Horário de funcionamento no Rio de Janeiro: 10h às 16h, de segunda-feira a sexta-feira.',
			},
			{
				menu: 'Horário',
				content: 'O território brasileiro abrange várias zonas horárias. Em relação ao GMT, a hora oficial de Brasília, seguida também no Rio de Janeiro e São Paulo, é 3 horas mais cedo (2 horas mais cedo no verão).',
			},
			{
				menu: 'Eletricidade',
				content: 'A corrente elétrica no Brasil é 220 volts, exceto nos estados de São Paulo, Rio de Janeiro e Pernambuco, onde é 110 volts. A única exceção no Rio de Janeiro é o Hotel Intercontinental, com 220 volts.',
			},
			{
				menu: 'Idioma',
				content: 'A língua oficial é português. A língua inglesa também é falada, principalmente nas principais cidades, mas a língua mais próxima ao portugês é o espanhol com o qual você poderá ser entendido.',
			},
			{
				menu: 'Clima',
				content: 'O clima varia desde a caatinga árida do interior até a impenetrável selva amazônica, no norte, passando pelas praias tropicais do Atlântico, no leste do país. O clima no sul é mais temperado. As estações da chuva: De janeiro a abril no norte (número médio de dias em que chove: 22); de abril a julho no nordeste (número médio de dias em que chove: 14); de dezembro a março na região entre Rio de Janeiro e São Paulo (número médio de dias em que chove: 10).',
			},
			{
				menu: 'Gorjetas',
				content: 'A grande maioria dos restaurantes e bares incluem 10% pelo serviço à conta. Lugares mais sofisticados podem cobrar até 15% a mais. Se o serviço não estiver incluído, deverá haver um aviso carimbado na conta. Os taxis não esperam gratificação, mas é comum arredondar a tarifa para cima. Em certas épocas é possível que o montante que se vê no taxímetro não seja o montante exato devido. Verifique se há uma tabela colada ao vidro traseiro do automóvel. Ali você poderá aferir o montante exato devido.',
			},
			{
				menu: 'Taxas',
				content: 'A taxa de embarque para vôos internacionais gira em torno de R$ 89,00. Para vôos domésticos a taxa vai de R$ 7,20 a R$ 9,20. Fora isso, todos os hotéis cobram uma taxa da prefeitura no valor de US$ 1,00 por dia por apartamento. Todas as taxas acima podem ser pagas em R$ ou US$, e devem ser quitadas no local.',
			},
			{
				menu: 'Comidas',
				content: 'Os pratos mais comuns levam diversas carnes, arroz e feijão preto. Restaurantes oferecem bufês de carnes grelhadas e outros pratos. A cozinha regional brasileira é ricamente variada e inclui acepipes como o Vatapá (camarão, óleo de peixe, leite de côco, pão e arroz) e Sarapatel (miúdos de porco, tomate, pimentão, cebola e molho). No Rio Grande do Sul, o churrasco impera como prato típico (carne na brasa, e molho campanha, com tomate e cebola). Da Amazônia vem o Tacacá (sopa espessa com camarão e alho). Há inúmeras variedades de bebidas alcoólicas disponíveis no mercado, inclusive excelentes cervejas: Antártica, Brahma, Cerpa, Skol. A aguardente mais popular é a cachaça, o ingrediente principal da Caipirinha, feita com limão em cubos, gelo e açúcar, ou adoçante. Não há restrições quanto a horários para servir bebidas alcoólicas. Dentre os refrigerantes, encontra-se o Guaraná, feito a partir da semente da planta do mesmo nome. Você poderá também tomar um dentre uma infindável variedade de sucos de frutas, incluindo alguns altamente vitaminados, dos quais você nunca ouviu falar. O café costuma ser servido forte e bastante açucarado. Se você quiser evitar açúcar, peça seu suco ou cafezinho com adoçante ou sem açúcar.',
			},
			{
				menu: 'Vestuário',
				content: 'O clima no Brasil vai de tropical no norte a temperado no sul. No país inteiro, as pessoas costumam vestir-se informalmente. Durante o dia, o ideal é usar camisas leves de algodão, bermudas vestidos e calças leves. Para sair à noite, costuma-se vestir camisa de mangas compridas, calças compridas e sapatos de couro. No Brasil você dificilmente vai precisar vestir paletó e gravata. No inverno (junho/julho), é boa idéia trazer um agasalho, posto que a temperatura pode cair bastante no sul do país.',
			},
			{
				menu: 'Compras',
				content: 'Assim como a comida, em um país do tamanho do Brasil há muitas especialidades locais para quem quiser ir às compras. As lojas permanecem abertas até tarde (em alguns dias até 22:00) nos grandes centros urbanos. O Rio de Janeiro e o sul se especializam em antigüidades e jóias. Compras especiais podem incluir gemas, (sobretudo esmeraldas) e jóias (especialmente de prata). No nordeste, dentre as especialidades encontram-se as rendas, as toalhas de mesa, lençóis etc. e a cerâmica.',
			},
			{
				menu: 'Segurança',
				contentHtml: `
					<span>
						Bem-vindo ao Brasil! Como em todas as grandes cidades ao redor do mundo, é importante estar atento e tomar algumas
						precauções básicas durante sua viagem. Com simples cuidados, você poderá aproveitar ao máximo sua experiência e se
						concentrar no que realmente importa: viver momentos inesquecíveis em nosso país.</span>
					<br><br>
					<span><b>Orientações essenciais para sua segurança e conforto:</b></span>
					<br>
					<ul>
						<li><span><b>Frequente áreas recomendadas:</b> Priorize locais como o centro de conferências, os principais hotéis e
								os pontos turísticos mais emblemáticos, como os bairros da Barra da Tijuca, Leblon, Ipanema e Copacabana. Não
								deixe de conhecer o Corcovado (Cristo Redentor) e o Pão de Açúcar, que são áreas amplamente frequentadas por
								turistas e regularmente patrulhadas, garantindo sua tranquilidade.</span></li>
						<li><span><b>Seja discreto:</b> Assim como em outras grandes metrópoles, recomendamos que você mantenha seus objetos
								pessoais, como telefones, joias e câmeras, de forma discreta enquanto estiver transitando pelas ruas. Isso ajuda a
								minimizar riscos e proporciona maior tranquilidade durante seus passeios.</span></li>
						<li><span><b>Deslocamentos noturnos:</b> Sempre que possível, evite andar sozinho durante a noite. Se planejar sair,
								prefira estar acompanhado e, se necessário, use o serviço de transporte de aplicativos ou táxis confiáveis,
								disponíveis amplamente na região.</span></li>
					</ul>
					<span><b>Experiência no Rio de Janeiro:</b></span>
					<br><br>
					<span>Milhares de turistas internacionais visitam o Rio de Janeiro todos os anos, seja para eventos acadêmicos,
						culturais ou de negócios, e saem com memórias incríveis. Com pequenos cuidados, sua experiência na "Cidade
						Maravilhosa" será não só segura, mas também enriquecida de oportunidades para aprendizado, conexão e descobertas
						únicas.</span>
					<br><br>
					<span>Desejamos a você uma estada inesquecível e esperamos que aproveite ao máximo tudo que o Brasil tem a oferecer.
						Estamos à disposição para auxiliar no que for necessário.</span>
					<style>
						ul {
							display: block;
							list-style-type: disc;
							margin-block-start: 1em;
							margin-block-end: 1em;
							padding-inline-start: 40px;
							unicode-bidi: isolate;
						}
					</style>
				`,
			},
			{
				menu: 'Praias',
				content: 'Uma parte significativa da cultura brasileira e do lazer dos brasileiros gira em torno da praia. Assim, as praias podem ser lugares muito divertidos e relaxantes. No entanto, lembre-se do seguinte ao ir à praia: dentro, e em torno das grandes cidades, as praias costumam estar bastante cheias de gente, e por isso os conselhos sobre segurança dados acima devem ser seguidos à risca. Além do mais, nunca vá à praia depois do anoitecer; leve consigo uma toalha ou esteira de praia pois há bastantes insetos na areia. Não se esqueça que o sol no Brasil pode incidir mais diretamente e com mais força do que na Europa, e tome as devidas precauções. Certas áreas, no Rio de Janeiro sobretudo, têm perigosas correntezas. Sabendo disso, fique na proximidade de outros banhistas e obedeça as bandeiras de sinalização: Vermelha - Perigo. É fortemente desaconselhável entrar no mar. Branca: A água está segura. Salva-vidas a postos.'
			}
		]

	},
	hotelInfo:{
		starRating: 'estrelas',
		description: 'Descrição',
		galleryTitle: 'Galeria de fotos',
		captionFallback: 'Legenda',
		closeGallery: 'Fechar galeria',
		previewGalleryLabel: 'Galeria do hotel',
		morePhotos: count => `Mais ${count} fotos`,
	},
  endingBankTicketReservation: {
    endingReservationMessage: {
      title: "Sua solicitação foi recebida com sucesso.",
      text: "Após o pagamento do boleto sua reserva estará confirmada. Caso o pagamento não seja identificado a solicitação será automaticamente cancelada.",
			viewBankTicketButton: 'Visualizar Boleto',
    }
  },
  conclusionBankTicketModal: {
    title: "Sua solicitação foi recebida com sucesso.",
    text: "Após o pagamento do boleto sua reserva estará confirmada. Caso o pagamento não seja identificado a solicitação será automaticamente cancelada.",
  },
	conclusionModal: {
		success: {
			title: 'Reserva efetuada com sucesso.',
			message: 'Em breve, enviaremos um e-mail com os detalhes da reserva.'
		},
		fail: {
			title: 'Reserva não efetuada.',
			message: 'Houve um problema na conclusão da reserva, tente novamente mais tarde.'
		}
	},
	clientTable: {
		id: 'Id',
		date: 'Data',
		client: 'Cliente',
		description: 'Descrição',
		status: 'Status',
		informationUnavailable: 'Informação indisponível'
	},
	conclusionErroClientFiles: {
		title: 'Erro!',
		message: 'Erro ao buscar files do cliente.'
	},
	resumeTableHeaderLabels: {
		name: 'Eventos em ',
		start: 'De',
		end: 'Até',
		local: 'Local'
	},
	resumeSubtitle: {
		title: 'CURRÍCULO',
		text: 'Realizamos congressos e eventos há mais de 30 anos em diferentes segmentos e somos referência no mercado. Com atuação e deslocamento de equipe em todo país, nossa empresa já realizou mais de 700 eventos, em 24 cidades brasileiras distribuídas em 12 estados, e mais o Distrito Federal.'
	},
	visaAndVaccine: {
		title: 'Visto e Vacina',
		vaccine: 'Vacinas: ',
		url: 'www.visitbrasil.com/key-information/health.html',
		vaccineInfo: 'Para saber se você precisa de visto para viajar ao Brasil, ',
		click: 'clique aqui.',
		vaccineMoreInfo: 'Essas informações podem ser alteradas pelo governo brasileiro, portanto antes de viajar sugerimos buscar informações atualizadas no órgão governamental competente de seu país.',
	},
	transferSection: {
		text: 'Aproveite a comodidade das opções de transfers que a Blumar Congressos e Eventos a agencia oficial para o {*} oferece para os congressistas. Reserve agora mesmo o seu transporte para o hotel, local do evento ou aeroporto. Aceitamos reservas para grupos ou individual.'
	},
	localTour: {
		title: 'Tour Locais em',
		selectText: 'ESCOLHA A CIDADE PARA VISUALIZAR OS TOURS:',
		selectOption: 'Quero reservar',
		description: 'Para os momentos de lazer dos participantes dos Eventos e para seus acompanhantes, oferecemos uma seleção especial de tours na cidade de realização do Evento. Além disso, fazemos também programas especiais de acordo com o perfil do evento e interesses especiais dos participantes.',
		priceText: 'Preço',
		noResult: 'Nenhum resultado encontrado',
		form: {
			title: 'Faça sua solicitação',
			hotel:'Hotel',
			name:'Nome',
			email:'Email',
			country:'País',
			date:'Data',
			message:'Observação',
			qtdPassenger:'Quantidade de passageiros',
			namePassenger:'Nome do passageiro',
			button: 'Solicitar',

			success: {
				title: 'Local Tour solicitado com sucesso',
				message: 'Em breve, entraremos em contato para prosseguir com a reserva.'
			},
			fail: {
				title: 'Erro ao reservar Local Tour',
				message: 'Houve um problema na reserva de Local Tours. Tente novamente mais tarde.'
			}
		},
		fail: {
			title: 'Erro ao buscar Local Tours',
			message: 'Houve um problema na busca de Local Tours. Tente novamente mais tarde.'
		}
	},
	invalidPaymentMessage: {
		bankTicket: {
			title: 'PRESADO CLIENTE',
			text: 'Houve um erro na hora de emitir o boleto.'
		},
		creditCard: {
			title: 'PREZADO CLIENTE',
			text: 'Pagamento não autorizado pelo cartão. Solicitamos que, por favor, entre em contato com a administradora do seu cartão, pois possíveis bloqueios de segurança podem ter impedido a cobrança. Certo de sua compreensão, BLUMAR TURISMO.'
		}
	},
	cancelConfirmationPolicy: {
		title: 'CONFIRMAÇÃO E CANCELAMENTO',
		description: (value) => `Ao clicar no botão "Concordo", declaro que estou de acordo que seja debitado imediatamente do meu cartão de crédito o valor de ${value} referente ao meu pedido de reserva, e concordo com as condições gerais e política de cancelamento e reembolso da Blumar Turismo conforme abaixo:`,
		bankticketDescription: 'Ao clicar no botão "Concordo", declaro que concordo com as condições gerais e política de cancelamento e reembolso da Blumar Turismo conforme abaixo:',
		firstCondition: 'Cancelamentos devem ser feitos por escrito: eventos@blumar.com.br',
		termsConfirmation: 'Li e concordo com os termos acima.'
	},
	privacyPolicy: {
		htmlContent: `
			<div class="privacy-policy-title">
				<span>Política de Privacidade da Blumar</span><hr>
			</div>
			<div class="privacy-policy-text">
				<p class="content-text">Esta Política de Privacidade descreve as práticas da BLUMAR ("Blumar"), em relação aos dados coletados por meio do site www.eventos.blumar.com.br ("Site"), de acordo com as leis em vigor.</p>
				<p class="content-text">Esta política se aplica aos dados que identificam membros, assinantes, clientes ou visitantes ("Usuário") individualmente ("Dados Pessoais") e demais dados fornecidos pelo Usuário ou coletados durante a utilização do Site. Em todos os casos, a Blumar cumpre com toda legislação brasileira aplicável à proteção de dados.</p>
				<p>1. CONDIÇÕES GERAIS</p>
				<p class="content-text">1.1. Todos os dados dos Usuários que usem o Site serão tratadas em concordância com a Lei nº 13.709, de 14 de agosto de 2020 (Lei Geral de Proteção de Dados).</p>
				<p class="content-text">1.2. Ao aceitar esta Política de Privacidade, o Usuário expressa sua concordância com a coleta e tratamento dos seus dados pessoais pela Blumar, incluindo o seu nome, e-mail, número de telefone e/ou celular, endereço, data de nascimento e/ou outros.</p>
				<p class="content-text">1.3. Ao aceitar esta Política de Privacidade, o Usuário expressa sua aceitação plena e sem reservas para todos os fins de direito. Assim, declara que fez leitura atenta e completa da presente Política de Privacidade. Se o Usuário não concordar com algum dos termos e regras aqui previstos, não deverá acessar e/ou utilizar o conteúdo.</p>
				<p class="content-text">1.4. A Blumar reserva-se ao direito de alterar este acordo, mediante informação prévia aos Usuários, sendo garantido a estes o direito de remover o seu consentimento para o tratamento de seus dados caso não concorde com as alterações.</p>
				<p>2. DADOS COLETADOS</p>
				<p class="content-text">2.1 Os dados são coletados quando inseridos ou submetidos voluntariamente pelo Usuário ao realizar um acesso por meio do Site.</p>
				<p class="content-text">2.2. Informações consideradas como Dados Pessoais identificáveis que coletamos a partir da navegação do Usuário no Site:</p>
				- logs<br>
				- cookies, por meio da ferramenta Google Analytics, que coleta de forma anônima e para fins analíticos, os seguintes dados:<br>
				a) idioma;<br>
				b) país e cidade;<br>
				c) navegador, sistema operacional e provedor de serviços;<br>
				d) resolução de tela, tipo de dispositivo (desktop ou celular), modelo do aparelho de celular; e<br>
				e) página que o usuário navega dentro do site, se está no site naquele momento, forma como o usuário acessou o Site (se foi via buscador ou direto pela URL do site), termo de pesquisa que utilizou no Site, tempo na página do Site.<br>
				<p class="content-text">2.3. O USUÁRIO poderá saber mais detalhes sobre o Google Analytics em "Como o Google utiliza os dados quando o usuário usa sites ou aplicativos dos nossos parceiros", localizado em .</p>
				<p class="content-text">2.4. Os dados coletados pela Google por meio do Google Analytics, bem como qualquer uso ou tratamento realizado em razão da referida coleta serão de responsabilidade única e exclusiva da Google, estando a Blumar isenta de quaisquer de qualquer responsabilidade decorrente.</p>
				<p class="content-text">2.5. Caso o Usuário não concorde com a coleta de dados pelo Google Analytics poderá desativá-lo por meio do Add-on do seu navegador, disponível no link https://tools.google.com/dlpage/gaoptout?hl=pt-BRs.</p>
				<p class="content-text">2.6. Cabe ao Usuário o dever de prestar informações corretas e atualizadas. Não somos responsáveis pela precisão, veracidade ou falta dela nas informações prestadas pelo Usuário.</p>
				<p class="content-text">2.7. Temos parceria com o Microsoft Clarity e o Microsoft Advertising para capturar como você usa e interage com nosso site por meio de métricas comportamentais, mapas de calor e reprodução de sessão para melhorar e comercializar nossos produtos/serviços. Os dados de uso do site são capturados usando cookies próprios e de terceiros e outras tecnologias de rastreamento para determinar a popularidade de produtos/serviços e atividades online. Além disso, usamos essas informações para otimização de sites, fins de fraude/segurança e publicidade. Para obter mais informações sobre como a Microsoft coleta e usa seus dados, visite a Declaração de Privacidade da Microsoft (https://privacy.microsoft.com/en-US/privacystatement).</p>
				<p>3. LINKS PARA SITES DE TERCEIROS</p>
				<p class="content-text">3.1. Ao navegar no Site, o Usuário poderá ser conduzido, via hiperlink, a conteúdos ou serviços ou a outros portais ou plataformas, que poderão coletar seus dados e ter sua própria política de privacidade.</p>
				<p class="content-text">3.2. Hiperlinks externos não constituem endosso pela Blumar dos sites/ambientes vinculados ou as informações, produtos ou serviços ali contidos. Esses hiperlinks são fornecidos apenas para sua consulta.</p>
				<p class="content-text">3.3. A Blumar não terá qualquer responsabilidade pelo material contido nesses sites nem qualquer associação com seus operadores.</p>
				<p class="content-text">3.4. A Blumar não controla esses sites e não é responsável por seu conteúdo ou pelo uso que o Usuário faça deles.</p>
				<p>4. COMO SERÃO UTILIZADAS AS INFORMAÇÕES</p>
				<p class="content-text">4.1. A Blumar poderá utilizar os dados que foram coletados e os registros das atividades no Sites para as seguintes finalidades:</p>
				i. prestação dos serviços contratados, pela Blumar ou por terceiros;<br>
				ii. contato com potenciais clientes;<br>
				iii. análise estatística de resultados;<br>
				iv. promoção dos serviços ofertados;<br>
				v. aperfeiçoamento dos serviços no site;<br>
				vi. melhora do conteúdo informado;<br>
				vii. defesa dos interesses em processos administrativos e judiciais; e/ou<br>
				viii. cumprimento de ordem judicial ou requerimento administrativo.<br>
				<p class="content-text">4.2. O consentimento referente à coleta e tratamento de dados fornecido pelo Usuário é fornecido de forma livre, expressa, individual, clara, específica e legítima.</p>
				<p class="content-text">4.3. Caso o Usuário não conceda seu consentimento para a elaboração do teste, os serviços não lhe serão disponibilizados.</p>
				<p class="content-text">4.4. Caso o Usuário não conceda seu consentimento para as finalidades facultativas, relacionadas ao envio de informações sobre hotéis, passeios, ofertas e promoções, entre outros materiais informativo, a prestação de serviços continuará sendo feita regularmente.</p>
				<p class="content-text">4.5. O Usuário reconhece e concorda que os seus Dados Pessoais coletados pela Blumar poderão ser compartilhados com terceiros prestadores dos serviços contratos pelo usuário, tais como hotéis, companhias aéreas e demais terceiros contratados.</p>
				<p class="content-text">4.6. Os dados coletados e as atividades registradas também poderão ser compartilhados com autoridades judiciais, administrativas ou governamentais competentes, sempre que houver requerimento, requisição ou ordem judicial.</p>
				<p class="content-text">4.7. Internamente, os dados de nossos Usuários são acessados somente por profissionais devidamente autorizados, respeitando os princípios de proporcionalidade, necessidade e relevância para os nossos objetivos, além do compromisso de confidencialidade e preservação da privacidade nos termos desta Política de Privacidade.</p>
				<p>5. ARMAZENAMENTO DOS DADOS E REGISTROS</p>
				<p class="content-text">5.1. Os dados e os registros de atividades coletados serão armazenados em ambiente seguro e controlado, pelo prazo mínimo de 6 (seis) meses, nos termos da Lei 12.965, de 23 de abril de 2014 (Marco Civil da Internet), observado o estado da técnica disponível.</p>
				<p class="content-text">5.2. Os dados serão excluídos antes desse prazo caso haja solicitação do Usuário, por meio do canal de atendimento indicado no item 6.1.</p>
				<p class="content-text">5.3. Para fins de auditoria, segurança ou controle de fraudes, ou caso exigido por lei ou decisão judicial, a Blumar poderá manter o histórico de registro dos dados dos Usuários por prazo superior, findo o qual serão excluídos com uso de métodos de descarte seguro.</p>
				<p class="content-text">5.4. Os dados coletados são armazenados em servidores próprios da Blumar, localizados no Brasil, bem como na nuvem, o que pode ensejar, nessa situação, a transferência ou processamento dos dados fora do Brasil, em países terceiros.</p>
				<p>6. EXIBIÇÃO, RETIFICAÇÃO E EXCLUSÃO DE DADOS</p>
				<p class="content-text">6.1. O Usuário poderá solicitar a exibição ou retificação de seus Dados Pessoais, por meio do e-mail viajepelobrasil@blumar.com.br .</p>
				<p class="content-text">6.2. Pela mesma ferramenta de atendimento o Usuário pode: a) Requerer a limitação do acesso e uso de seus Dados Pessoais; b) Manifestar sua oposição ao uso de seus Dados Pessoais; e c) Solicitar a exclusão de seus Dados Pessoais coletados e registrados pela Blumar.</p>
				<p class="content-text">6.3. Caso o Usuário revogue seu consentimento para finalidades fundamentais do Site, os serviços e funcionalidades do mesmo poderão ficar indisponíveis para esse Usuário.</p>
				<p>7. PROPRIEDADE INTELECTUAL</p>
				<p class="content-text">7.1 Cada um dos textos, fotografias, projetos, plantas, imagens, vídeos, ilustrações, ícones, tecnologias, links e demais conteúdos audiovisuais ou sonoros, incluindo o software do Site, desenhos gráficos e códigos fonte, são de propriedade exclusiva da Blumar ou de terceiros que tenham autorizado sua utilização no Site, estando protegidos pelas leis e tratados internacionais, vedada sua cópia, reprodução, ou qualquer outro tipo de utilização, ficando os infratores sujeitos às sanções civis e criminais correspondentes, nos termos das Leis 9.279/96, 9.609/98, e 9.610/98.</p>
				<p class="content-text">7.2 As marcas, os nomes comerciais ou logotipos de qualquer espécie apresentados por meio do Site são de propriedade da Blumar ou de terceiros que permitiram o seu uso, de modo que a utilização do Site não consiste em autorização para que o Usuário possa citar tais marcas, nomes comerciais e logotipos.</p>
				<p>8. LEI APLICÁVEL E JURISDIÇÃO</p>
				<p class="content-text">8.1. Esta Política de Privacidade e a relação decorrente das ações aqui compreendidas, assim como qualquer disputa que surja em virtude disto será regulada exclusivamente pela legislação brasileira.</p>
				<p class="content-text">8.2. Fica eleito o Foro Central da Comarca da Capital do Estado do Rio de Janeiro para dirimir qualquer questão envolvendo o presente documento, renunciando as partes a qualquer outro, por mais privilegiado que seja ou venha a ser.</p>
			</div>

			<div class="privacy-policy-title">
				<span>POLÍTICA DE COOKIES</span><hr>
			</div>
			<div class="privacy-policy-text">
				<p>O que são Cookies</p>
				<p class="content-text">Cookies são pequenos arquivos de texto que são colocados no seu dispositivo eletrônico quando você visita nosso website. Estes pequenos arquivos servem para reconhecer, acompanhar e armazenar a sua navegação como usuário na Internet.</p>
				<p class="content-text">Os Cookies são amplamente utilizados para garantir a operação mais eficiente do website e para observar hábitos de visita.</p>
				<p class="content-text">Para melhorar sua experiência, utilizamos Cookies combinados a outras tecnologias semelhantes.</p>
				<p>Porque usamos Cookies</p>
				<p class="content-text">Usamos Cookies por vários motivos. Alguns são necessários por razões técnicas, para garantir o bom funcionamento do website.</p>
				<p class="content-text">Outros Cookies oferecem uma melhor experiência no website em razão da memorização de algumas de suas atividades (inclusive através de nossos plug-ins, widgets e conteúdo integrado), além de Cookies que possibilitam uma melhor análise de navegação e que exibem publicidade mais relevante.</p>
				<p>Quais os tipos de Cookies</p>
				<p class="content-text">Os Cookies podem ser:</p>
				<p class="content-text">Cookies Proprietários - são Cookies definidos por nós, ou em nosso nome, e usados em nosso website;</p>
				<p class="content-text">Cookies de Terceiros - são Cookies definidos por terceiros, utilizados fora ou dentro do nosso website, que podem ter acesso aos dados do seu dispositivo, mas não podem coletar seu nome, informações de contato ou outras informações pessoais, a menos que você decida divulgar seus dados.</p>
				<p class="content-text">Cookies Essenciais ou Estritamente Necessários - Estes cookies são necessários para que o website e não podem ser desligados nos nossos sistemas. Normalmente, eles só são configurados em resposta a determinadas ações e que correspondem a uma solicitação de serviços, tais como definir as suas preferências de privacidade, iniciar sessão ou preencher formulários. Você pode configurar o seu navegador para bloquear ou alertá-los, mas algumas partes do website não funcionarão devidamente.</p>
				<p class="content-text">Cookies de Desempenho - Estes Cookies permitem contabilizar visitas e fontes de tráfego, para que possamos medir e melhorar o desempenho do nosso website. Eles ajudam a saber quais são as páginas mais e menos populares e a ver como os visitantes navegam pelo website.</p>
				<p class="content-text">Cookies de Funcionalidade - Estes Cookies permitem que o website forneça funcionalidades e personalização melhoradas. Podem ser estabelecidos por nós (Proprietários) ou por fornecedores externos (Terceiros), cujos serviços agregamos às nossas páginas.</p>
				<p class="content-text">Cookies de Publicidade - Estes cookies podem ser estabelecidos por meio do website e pelos nossos parceiros de publicidade. Podem ser usados por essas empresas para analisar e/ou construir um perfil sobre os seus interesses e otimizar anúncios relevantes em outros websites.</p>
				<p class="content-text">Cookies de Redes Sociais - Estes Cookies são estabelecidos por uma série de serviços das redes sociais que adicionamos ao nosso website para permitir que possa compartilhar o nosso conteúdo com os seus amigos e conhecidos. Eles são capazes de rastrear a sua navegação por outros websites e criar um perfil sobre os seus interesses.</p>
				<p>Como alterar ou bloquear cookies</p>
				<p class="content-text">A maioria dos navegadores é configurada para aceitar automaticamente os cookies. Você pode, contudo, alterar as configurações para bloquear cookies ou alertá-lo quando um cookie estiver sendo enviado ao seu dispositivo. Existem várias formas de gerenciar cookies, sendo possível criar um bloqueio geral para cookies, bloquear cookies de um site específico e até mesmo bloquear cookies de terceiros em relação a um site. Bloquear todos os cookies vai afetar o funcionamento da sua experiência, pois não será possível identificar suas preferências e recomendar conteúdo e publicidade relevantes.</p>
				<p class="content-text">Consulte as instruções do seu navegador para saber mais sobre como ajustar ou alterar suas configurações, lembrando que a configuração desejada deve ser replicada em todos os dispositivos utilizados para acessar os Serviços (como computadores, smartphones, tablets).</p>
				<p>Atualizações</p>
				<p class="content-text">Podemos atualizar esta Política de Cookies a qualquer tempo. Quaisquer alterações entrarão em vigor a partir da data em que forem publicadas, ou conforme exigido por lei, e serão devidamente comunicadas através dos nossos canais de comunicação do website.</p>
			</div>
		`,
	},
	staticPages: {
		companyProfile: {
			title: 'Quem somos?',
			introduction: 'A Blumar Turismo é uma operadora de turismo com mais de 30 anos de experiência e líder de mercado, contando hoje com clientes ativos distribuídos em todos os continentes.',
			segmentsLabel: 'Atuamos nos seguintes segmentos:',
			segments: [
				'Turismo Receptivo Internacional',
				'Viagens Corporativas e de Incentivo',
				'Logística de Turismo de Congressos e Eventos',
			],
			operations: 'Com uma equipe jovem, dinâmica e multilíngue, cuidamos de toda a logística de turismo do evento desde sua captação até a operação e fechamento. Todos os processos são gerenciados e supervisionados por profissionais altamente qualificados, experientes e prontos para responder a todas as solicitações. Temos como foco a excelência na qualidade de nossos serviços, primando pela seriedade e transparência em suas negociações.',
			vision: 'A Blumar busca ser uma empresa reconhecida por seus clientes, fornecedores e concorrentes como a mais criativa e confiável empresa de eventos do mercado, permanecendo entre as líderes nos principais segmentos: Receptivo, Incentivo e Eventos.',
			mission: {
				title: 'Nossa Missão',
				text: 'Satisfazer às necessidades dos clientes e superar suas expectativas no que diz respeito a lazer, cultura e negócios, provendo serviços de acomodação, transporte e acompanhamento de alta qualidade.',
			},
			clients: {
				title: 'Número de clientes',
				text: 'Contamos com mais de 1.000 clientes ativos distribuídos em todos os continentes.',
			},
			differentials: {
				title: 'Diferenciais Blumar',
				items: [
					{
						title: 'Experiência e conhecimento especializado',
						text: 'Mais de 40 anos no ramo, com profundo conhecimento do cenário turístico brasileiro e serviços que abrangem todos os aspectos de viagens no Brasil.',
					},
					{
						title: 'Conhecimento local',
						text: 'Nossa equipe conhece o destino em primeira mão e é capaz de oferecer produtos e experiências verdadeiramente únicas. Temos orgulho de contar com uma equipe multinacional e multilíngue atuando em todo o Brasil.',
					},
					{
						title: 'Produtos inovadores',
						text: 'Nunca paramos de criar... Buscamos estar na vanguarda do desenvolvimento de novos produtos, criando embalagens e experiências únicas e fora do comum.',
					},
					{
						title: 'Tecnologia de ponta',
						text: 'Uma plataforma web avançada que simplifica o processo de reserva para os clientes, oferecendo fácil acesso aos melhores hotéis, passeios e serviços disponíveis no Brasil.',
					},
					{
						title: 'Gestão e finanças sólidas',
						text: 'Nossas credenciais no mercado são excelentes. Como clientes-chave e parceiros preferenciais de todos os principais hotéis do Brasil, podemos oferecer mais segurança para a sua operação.',
					},
					{
						title: 'Social e ecologicamente responsável',
						text: 'Como empresa, a Blumar se empenha em apoiar as comunidades locais nos destinos em que atua, além de minimizar seu impacto ambiental.',
					},
				],
			},
			structure: {
				title: 'Estrutura do Departamento de Eventos',
				paragraphs: [
					'Nossa equipe de Eventos é formada por 15 profissionais experientes e comprometidos. O primeiro contato com o cliente é realizado pela equipe comercial do departamento, que procura entender as necessidades do cliente e elaborar a proposta mais personalizada possível. Em nossas negociações oferecemos benefícios e diferenciais exclusivos, assim como flexibilidade na elaboração de pacotes, descontos e formas de pagamento.',
					'Para cada evento captado, além de uma equipe operacional definimos uma coordenadora para o evento, conforme seu perfil e experiência no segmento.',
					'Dentre as principais funções, fazemos atendimento personalizado à comissão organizadora da entidade e à empresa organizadora do congresso. Atentamente, prestamos assessoria aos convidados e palestrantes, cuidando da logística de sua viagem, auxiliando na escolha dos melhores serviços e atendendo suas dúvidas.',
					'Tal atendimento é feito previamente ao evento e, ainda, no próprio local deste. Podemos dispor também de um Desk de apoio da Blumar montado especialmente para satisfazer a todas as necessidades dos clientes durante o evento.',
					'Nós operamos eventos, congressos e simpósios de diferentes portes em todo o país, sejam eles nacionais ou internacionais e de distintos segmentos. Valendo-se do excelente relacionamento comercial que a Blumar desenvolveu com o Trade Turístico, contamos com parceiros capacitados e oferecemos apoio local e deslocamento da equipe para cada evento operado.',
				],
			},
		},
		accommodation: {
			title: 'Hospedagem',
			lead: 'A Blumar possui acordos com hotéis em todo Brasil. Pelo tempo de mercado e volume de negócios garantimos excelentes negociações, condições e tarifas.',
			items: [
				{
					number: '1',
					title: 'Suporte e Assistência na escolha dos hotéis',
					text: 'Ao ser credenciada como Agência de Turismo Oficial, a equipe analisa o perfil do Evento e, junto com a Comissão Organizadora, escolhe os hotéis que farão parte da grade oficial e serão disponibilizados para os participantes, de acordo com o perfil do evento.',
				},
				{
					number: '2',
					title: 'Negociação de tarifas especiais',
					text: 'Assim como o Congresso, a Blumar também tem interesse em trazer para o Evento o maior número possível de participantes. Para isso, negociamos tarifas especiais com os hotéis, em diversas faixas de preço, para todos os perfis de participantes.',
				},
				{
					number: '3',
					title: 'Flexibilidade de escolha',
					text: 'Para atendermos a todos os perfis de participantes, a Blumar sempre disponibiliza diferentes opções de hotéis, de diversos preços, categorias e localizações, sempre visando a satisfação de nossos clientes.',
				},
				{
					number: '4',
					title: 'Sistema de Gerenciamento de reservas',
					text: 'Possuímos um sistema de Reservas verdadeiramente on-line. Através desse sistema, os participantes podem fazer suas reservas de forma rápida e segura, obtendo uma confirmação imediata. E ainda oferecemos ao cliente final, acesso a relatório de reservas efetuadas através de um log in e senha.',
				},
			],
		},
		flightBookings: {
			title: 'Passagem Aérea',
			intro: [
				'A Blumar possui um departamento especifico que cuida da negociação, cotação e emissão das passagens aéreas de eventos. O departamento conta com uma equipe de profissionais experientes e exclusivos, que estão sempre em busca da melhor oferta para os nossos clientes.',
				'Somos uma agencia IATA, fazemos reservas e emissões de passagens aéreas em todo Brasil e exterior, utilizando o sistema Amadeus, E-TAM e o portal da GOL, Azul, Avianca e Trip. Para os eventos ainda oferecemos:',
			],
			items: [
				{
					number: '1',
					title: 'Assessoria na escolha da transportadora aérea oficial',
					text: 'Muitas vezes é interessante para um Evento estabelecer uma transportadora aérea oficial. Com isso, é possível obter mais benefícios em passagens e condições. Nesse caso, a Blumar com sua experiência de mercado, auxilia e acompanha todo o processo, desde as propostas e negociações até a escolha final.',
				},
				{
					number: '2',
					title: 'Negociação de descontos exclusivos',
					text: 'Por ser uma operadora de Turismo e Agência de Receptivo, a Blumar possui ótimos contatos comerciais com todas as companhias aéreas. Uma vez credenciada como Agência Oficial de um evento, negociamos descontos de até 15% dos valores públicos nos sites das principais cias. aéreas, para passagens emitidas para os participantes do evento.',
				},
				{
					number: '3',
					title: 'Emissão de passagens aéreas para palestrantes e convidados',
					text: 'Contando com uma equipe altamente personalizada e especializada em atendimento vip, a Blumar fica a disposição da Sociedade ou Empresa para entrar em contato com os palestrantes e convidados e oferecer a melhor opção de passagem aérea. Enviamos relatórios padronizados para controle geral das emissões com a periodicidade solicitada.',
				},
			],
		},
		transportation: {
			title: 'Transporte',
			lead: 'Oferecemos os serviços de:',
			items: [
				{
					number: '1',
					title: 'Transfer',
					text: 'Para maior comodidade dos participantes do evento, oferecemos a alternativa de reserva de transporte do aeroporto para o hotel e do hotel para o aeroporto.',
				},
				{
					number: '2',
					title: 'Shuttle',
					text: 'Muitos eventos colocam à disposição dos participantes um serviço de transporte dos hotéis para o Centro de Convenções, além de pessoal especializado para coordenar este serviço e guias para todos os ônibus. Nesse caso, a Blumar se responsabiliza por negociar os melhores preços e condições, elaborar o projeto e rotas e atua sempre com as melhores empresas do mercado, dando maior segurança e conforto aos participantes.',
				},
				{
					number: '3',
					title: 'Outros',
					text: 'Organizamos também o aluguel de ônibus, micro-ônibus, van, sprinter, carros de passeio e carros blindados. Negociamos com frotas de taxis especiais e locadoras de carros para que fiquem à disposição dos participantes, quando solicitado. A Blumar Turismo organiza a recepção no aeroporto e atendimento aos passageiros com informações e providências para os traslados.',
				},
			],
		},
	},
	eventStamps: {
		BLUMAR_RECOMMENDS: 'Blumar Recomenda',
		SHUTTLE: 'Shuttle',
		SPECIAL_OFFER: 'Oferta Especial',
		WALK: 'Walk',
	}
}



// WEBPACK FOOTER //
// ./src/assets/translationPt.js